export const STATUS_MAP = {
  none: '依頼中',
  rejected: '再依頼中',
  applying: '承認待ち',
  accepted: '完了',
  canceled: '取下げ',
}
export const STATUS: (keyof typeof STATUS_MAP)[] = ['none', 'rejected', 'applying', 'accepted', 'canceled']
